/*
 * Augment the Element class with some methods that are specific to a given
 * element. These are grouped here to de-clutter the main class declaration
 * which thus only contains generic methods.
 *
 * {@link https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation
 */
import { None, Some } from "@siteimprove/alfa-option";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Sequence } from "@siteimprove/alfa-sequence";
import { Element } from "../element.js";
const { isElement } = Element;
const { and } = Refinement;
Element.prototype.inputType = function () {
    if (this._inputType === undefined) {
        this._inputType = this.attribute("type")
            .flatMap((attribute) => attribute.enumerate("hidden", "search", "tel", "url", "email", "password", "date", "month", "week", "time", "datetime-local", "number", "range", "color", "checkbox", "radio", "file", "submit", "image", "reset", "button", "text"))
            .getOr("text");
    }
    return this._inputType;
};
Element.prototype.displaySize = function () {
    if (this._displaySize === undefined) {
        this._displaySize = this.attribute("size")
            .flatMap((attribute) => {
            const size = parseInt(attribute.value, 10);
            if (size === size && size === (size | 0)) {
                return Some.of(size);
            }
            return None;
        })
            .getOrElse(() => (this.attribute("multiple").isSome() ? 4 : 1));
    }
    return this._displaySize;
};
Element.prototype.optionsList = function () {
    if (this._optionsList === undefined) {
        this._optionsList = this.children()
            .filter(isElement)
            .flatMap((child) => {
            switch (child.name) {
                case "option":
                    return Sequence.from([child]);
                case "optgroup":
                    return child
                        .children()
                        .filter(isElement)
                        .filter(
                    // We cannot really use `Element.hasName` here as it would
                    // create a circular dependency.
                    (grandchild) => grandchild.name === "option");
                default:
                    return Sequence.empty();
            }
        });
    }
    return this._optionsList;
};
Element.prototype.isSummaryForItsParentDetails = function () {
    // We cannot use `Element.hasName` here as it would create a circular dependency.
    return this.parent()
        .filter(and(Element.isElement, (parent) => parent.name === "details"))
        .some((details) => details
        .children()
        .find(and(Element.isElement, (candidate) => candidate.name === "summary"))
        .includes(this));
};
//# sourceMappingURL=augment.js.map